import React, { useState, useEffect } from 'react';
import { Modal, Spinner, Table, Alert, Card, Pagination, Button, Form } from '@themesberg/react-bootstrap';

import axios from "axios";
import Layout from "../../components/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from '../../constants';
import { useAuth } from '../../Context/AuthContext';
import ShelterSettings from '../../components/ShelterSettings';
import { Row } from 'react-bootstrap';
const RefugeesAvailability = () => {
  const [refugees, setRefugees] = useState([]); 
  const [infoMessage, setInfoMessage] = useState([]); 
  const [availableRefugees, setAvailableRefugees] = useState([]);
  const [notAvailableRefugees, setNotAvailableRefugees] = useState([]);
  const [selectedRefugee, setSelectedRefugee] = useState(null); // For modal
  const [refugeeDetails, setRefugeeDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingAvailability, setLoadingAvailability] = useState(false);
  const {user} = useAuth();
  const shelterId = user.shelter.id;
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
const [dayThreshold, setDayThreshold] = useState(null);
const [autoCheckoutHours, setAutoCheckoutHours] = useState(null);

const adminId = JSON.parse(localStorage.getItem("userData"))?.id;







useEffect(() => {
  if (!shelterId) return;

  const fetchSettings = async () => {
    try {
      // Absent Days
      const resAbsent = await axios.get(`${BASE_URL}/shelters/${shelterId}/absent-days`);
      if (resAbsent.data && typeof resAbsent.data.absentDays === "number") {
        setDayThreshold(resAbsent.data.absentDays);
      }

      // Auto Checkout Hours
      const resAuto = await axios.get(`${BASE_URL}/shelters/${shelterId}/auto-checkout-hours`);
      if (resAuto.data && typeof resAuto.data.autoCheckoutHours === "number") {
        setAutoCheckoutHours(resAuto.data.autoCheckoutHours);
      }

    } catch (err) {
      console.error("Failed to fetch settings:", err);
    }
  };

  fetchSettings();
}, [shelterId]);


 
  const fetchRefugees = async () => {
  try {
    setLoadingAvailability(true);
    const response = await axios.get(`${BASE_URL}/refugees/availability/${shelterId}`);
    const data = response.data;

    if (!data || typeof data !== "object") {
      setInfoMessage("No refugees available in this shelter.");
      setRefugees([]);
      return;
    }

    const available = Array.isArray(data.available) ? data.available : [];
    const notAvailable = Array.isArray(data.notAvailable) ? data.notAvailable : [];

    if (available.length === 0 && notAvailable.length === 0) {
      setInfoMessage("No refugees available in this shelter.");
      setRefugees([]);
      return;
    } else {
      setInfoMessage("");
    }

    // Map available refugees with status and lastAction
    const availableWithStatus = available.map((refugee) => {
      let lastAction = "—";
      if (Array.isArray(refugee.availability) && refugee.availability.length > 0) {
        const sorted = [...refugee.availability].sort(
          (a, b) =>
            new Date(b.date || b.checkDetails?.checkIn || b.checkDetails?.checkOut) -
            new Date(a.date || a.checkDetails?.checkIn || a.checkDetails?.checkOut)
        );
        const lastEntry = sorted[0];
        if (lastEntry.checkDetails?.checkOut) lastAction = "checkOut";
        else if (lastEntry.checkDetails?.checkIn) lastAction = "checkIn";
      }
      return {
        ...refugee,
        status: "Available",
        lastAction
      };
    });

    // Map not available refugees with status and lastAction
    const notAvailableWithStatus = notAvailable.map((refugee) => {
      let lastAction = "—";
      if (Array.isArray(refugee.availability) && refugee.availability.length > 0) {
        const sorted = [...refugee.availability].sort(
          (a, b) =>
            new Date(b.date || b.checkDetails?.checkIn || b.checkDetails?.checkOut) -
            new Date(a.date || a.checkDetails?.checkIn || a.checkDetails?.checkOut)
        );
        const lastEntry = sorted[0];
        if (lastEntry.checkDetails?.checkOut) lastAction = "checkOut";
        else if (lastEntry.checkDetails?.checkIn) lastAction = "checkIn";
      }
      return {
        ...refugee,
        status: "Not Available",
        lastAction
      };
    });

    setAvailableRefugees(availableWithStatus);
    setNotAvailableRefugees(notAvailableWithStatus);
    setRefugees([...availableWithStatus, ...notAvailableWithStatus]);

  } catch (err) {
    console.error("Error fetching refugees:", err);
    setError("Failed to load data. Please try again later.");
  } finally {
    setLoadingAvailability(false);
  }
};



useEffect(() => {
  fetchRefugees();
}, [shelterId]);


useEffect(() => {
  fetchRefugees();
}, []);


const fetchRefugeeDetails = async (refugeeId) => {
  try {
    setLoading(true);
    const response = await axios.get(`${BASE_URL}/refugees/${refugeeId}/availability`);
    const data = response.data;

    const updatedAvailability = data.availability.map((entry) => {
      if (entry.checkDetails?.checkIn) {
        const lastCheckInDate = new Date(entry.checkDetails.checkIn);
        const currentDate = new Date();
        const diffInDays = Math.floor((currentDate - lastCheckInDate) / (1000 * 60 * 60 * 24));
        entry.available = diffInDays <= dayThreshold;
      } else {
        entry.available = false;
      }
      return entry;
    });

    // Ensure the refugee _id exists
    const refugeeWithId = {
      _id: refugeeId, // ✅ add this
      ...data,
      availability: updatedAvailability
    };

    setRefugeeDetails(refugeeWithId);
    setSelectedRefugee(refugeeWithId);
  } catch (err) {
    console.error("Error fetching refugee details:", err);
    setError(err.response?.data?.message || "Failed to load refugee details");
  } finally {
    setLoading(false);
  }
};


  const handleCloseModal = () => {
    setSelectedRefugee(null);
    setRefugeeDetails(null);
  };


const handleCheckIn = async () => {
  if (!selectedRefugee?._id) {
    setError("No refugee selected for check-in.");
    return;
  }

  try {
    setLoading(true);

    // Send check-in request
    await axios.post(`${BASE_URL}/refugees/checkin/${selectedRefugee._id}`, { checkedInBy: adminId });

    // Refresh the refugee details immediately
    await fetchRefugeeDetails(selectedRefugee._id);

    // Refresh the main table of refugees
    await fetchRefugees();

    // Show success message
    setInfoMessage(` ${selectedRefugee.firstName} ${selectedRefugee.lastName} successfully checked in!`);
    setError(null);

  } catch (error) {
   
    setError(` Failed to check-in: ${error.response?.data?.message || error.message}`);
    setInfoMessage(null);

  } finally {
    setLoading(false);

    // Auto hide messages after 5 seconds
    setTimeout(() => {
      setInfoMessage(null);
      setError(null);
    }, 5000);
  }
};



  const getPaginatedRefugees = (refugees) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return refugees.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil(refugees.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Layout>
      <div className="container mt-5">
        <h2 className="text-center mb-4 text-primary">User Availability</h2>


      
       

<ShelterSettings shelterId={user.shelter.id} />
    




        {error && <Alert variant="danger">{error}</Alert>}
  
        {loadingAvailability ? (
   <div className="text-center">
   <Spinner animation="border" role="status" />
 </div>
) : Array.isArray(refugees) && refugees.length > 0 ? (
        <Card border="light" className="shadow-sm mt-3" style={{ maxHeight: "500px" }}>
                  <Card.Body className="pt-0">
          <Table hover className="user-table align-items-center" responsive>
  <thead>
    <tr>
      <th scope="col">First Name</th>
      <th scope="col">Last Name</th>
      <th scope="col">Status</th>
      <th scope="col">Last Action</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
  {getPaginatedRefugees(refugees).map((refugee) => (
    <tr key={refugee._id}>
      <td>{refugee.firstName}</td>
      <td>{refugee.lastName}</td>
      <td>
        <span
          className={`badge ${
            refugee.status === "Available" ? "bg-success" : "bg-danger"
          } text-light`}
        >
          {refugee.status}
        </span>
      </td>
        <td>
  <span
    className={`badge ${
      refugee.lastAction === "checkIn" ? "bg-success" :
      refugee.lastAction === "checkOut" ? "bg-warning text-light" : "bg-secondary"
    }`}
  >
    {refugee.lastAction
      ? refugee.lastAction.replace(/([a-z])([A-Z])/, '$1 $2')
      : '—'}
  </span>
</td>
      <td>
<Button variant="light" size="sm"  className="responsive-btn" onClick={() => fetchRefugeeDetails(refugee._id)}>
   See Details →
  </Button>
</td>

    </tr>
  ))}
</tbody>

</Table>

           <Pagination className="mt-3">
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
      
          </Card.Body>
     

        </Card>
        
        ) : (
          <div className="card mt-3">
          <div className="card-body">
            <p className="card-text">Currently, there are no User available in this shelter.</p>
          </div>
        </div>
        )}
        
        {/* Modal for refugee details */}
        {selectedRefugee && (
          <Modal show={true} onHide={handleCloseModal} size="lg" centered>
           <Modal.Header closeButton>
  <Modal.Title className="d-flex justify-content-between align-items-center w-100">
    <span>
      Availability for {selectedRefugee.firstName} {selectedRefugee.lastName}
    </span>
 
  </Modal.Title>
</Modal.Header>

          <Modal.Body>
  {/* Display success or error message */}
  {infoMessage && <Alert variant="success">{infoMessage}</Alert>}
  {error && <Alert variant="danger">{error}</Alert>}

  {loading ? (
    <div className="d-flex justify-content-center align-items-center">
      <Spinner animation="border" variant="primary" />
      <span className="ms-2">Loading details...</span>
    </div>
  ) : refugeeDetails && refugeeDetails.availability ? (
    <div>
      <Table className="table table-hover table-bordered">
        <thead className="table-light">
          <tr>
            <th>Check-In</th>
            <th>Check-Out</th>
          </tr>
        </thead>
        <tbody>
          {refugeeDetails.availability.map((entry) => (
            <tr key={entry._id}>
              <td>
                {entry.checkDetails.checkIn ? (
                  <>
                    <div className="check-details">
                      <div className="check-date"><strong>Date:</strong> {new Date(entry.checkDetails.checkIn).toLocaleDateString()}</div>
                      <div className="check-time"><strong>Time:</strong> {new Date(entry.checkDetails.checkIn).toLocaleTimeString()}</div>
                    </div>
                  </>
                ) : (
                  <span style={{ color: 'red' }}>No Check-In</span>
                )}
              </td>
              <td>
                {entry.checkDetails.checkOut ? (
                  <>
                    <div><strong>Date:</strong> {new Date(entry.checkDetails.checkOut).toLocaleDateString()}</div>
                    <div><strong>Time:</strong> {new Date(entry.checkDetails.checkOut).toLocaleTimeString()}</div>
                  </>
                ) : (
                  <span style={{ color: 'red' }}>No Check-Out</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
  

      {/* Alert for refugees not available for more than threshold */}
{selectedRefugee.status === "Not Available" &&
 (() => {
   const lastEntry = selectedRefugee.availability?.length
     ? [...selectedRefugee.availability].sort(
         (a, b) =>
           new Date(b.checkDetails?.checkIn || b.checkDetails?.checkOut || b.date) -
           new Date(a.checkDetails?.checkIn || a.checkDetails?.checkOut || a.date)
       )[0]
     : null;

   const lastCheck = lastEntry?.checkDetails?.checkOut || lastEntry?.checkDetails?.checkIn;
   const diffInDays = lastCheck
     ? Math.floor((new Date() - new Date(lastCheck)) / (1000 * 60 * 60 * 24))
     : null;

   return diffInDays !== null && diffInDays > dayThreshold ? (
     <Alert variant="warning" className="mt-3">
       A User hasn’t checked in for more than {dayThreshold} days!
     </Alert>
   ) : null;
 })()
}


  

    </div>
  ) : (
    <p>No details available</p>
  )}
</Modal.Body>

            <Modal.Footer>
                 <button
      className="btn btn-success"
      onClick={handleCheckIn}
      disabled={loading}
    >
      {loading ? "Processing..." : "Check-In"}
    </button>
              <button className="btn btn-secondary" onClick={handleCloseModal}>
                Close
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </Layout>
  );
};

export default RefugeesAvailability;